export default __webpack_public_path__ + "static/media/logo_flixbus.358feb70.svg";